import md5 from 'md5';

export const getGravatarUrl = (email: string, size: number = 80): string => {
  const hash = md5(email.trim().toLowerCase());
  return `https://gravatar.com/avatar/${hash}?s=${size}&d=identicon`;
};
